import React, { Component } from 'react'
import _ from 'lodash'

import StatusModal from 'components/statusModal'
import { Get } from 'utils/axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      requests: [],
      loading: false,
      showStatusModal: false,
      statusModalType: '',
      onClickStatusModalButton: () => {},
      statusModalMessage: '',
      rejectOptions: []
    }

    load = param => this.setState({ loading: param })
    requestError = error => this.setState({
      showStatusModal: true,
      statusModalType: 'warning-custom',
      onClickStatusModalButton: () => this.setState({ showStatusModal: false }),
      statusModalMessage: error
    })
    requestSuccess = success => this.setState({
      showStatusModal: true,
      statusModalType: 'positive',
      onClickStatusModalButton: () => this.setState({ showStatusModal: false }),
      statusModalMessage: success
    })

    getRejectOptions = () => Get( 
      `/reject_options`,
      this.getRejectOptionsSuccess,
      this.getRejectOptionsError,
      this.load
    )
    getRejectOptionsSuccess = payload => {
      let tempData = []
      payload.map( item => {
        tempData.push({
          ... item,
          value: `${ item.id }` 
        })
      })
      this.setState({ rejectOptions: [
        { id: '', value: '', description: '' },
        ... tempData
      ]})
    }
    getRejectOptionsError = error => this.requestError( error )

    render = () => {
      return (
        <>
          <WrappedComponent
            { ...this.props } 
            rejectOptions={ this.state.rejectOptions }
            onLoadRejecOption={ this.state.loading }
            getRejectOptions={ this.getRejectOptions }/>
          <StatusModal
            isOpen={ this.state.showStatusModal }
            type={ this.state.statusModalType }
            message={ this.state.statusModalMessage ? this.state.statusModalMessage : 'You might be disconnected from the Internet, please reconnect and refresh the page to use Atlas again.' }
            onClick={ this.state.onClickStatusModalButton } />
        </>
      )
    }
  }
  return WithHOC
}

export default HOC